import classNames from 'classnames';
import Typography from 'components/gruenland/atoms/typography';

type FeedbackProps = {
  error: string;
  success: string;
};

const Feedback: React.FC<FeedbackProps> = ({ error, success }) => {
  const feedBackElementClassName = classNames('mb-3 text-[12px]', {
    'text-green-600': success,
    'text-accent-red': !success,
  });

  if (!error && !success) return <></>;

  return <Typography className={feedBackElementClassName}>{error || success}</Typography>;
};

export default Feedback;
